<template lang="pug">
.k-menu
  slot
</template>

<script lang="js">

export default {
  name: 'MenuBlock',
  mixins: [],
  components: {},
  props: {},
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {},
  computed: {}
}
</script>

<style lang="scss">
.k-menu {
}
</style>
